module.exports = __webpack_public_path__ + "img/ecf8d28.jpg";